import { PageModel } from "./PageModel";

class TargetOrientedPage extends PageModel {


}

export {TargetOrientedPage}